export default __webpack_public_path__ + "static/media/detail_mobile_16_6.ce37f1e5.jpg";